module.exports = __webpack_public_path__ + "media/packs/images/flags/ZA-7b435ffc47a160d961ced583c33f50d3.png";